"use client";

import React from "react";
import Image from "next/image";
import { Icons } from "@/const/icons";
import { STPopover } from "../STPopover";
import { toast } from "react-toastify";
import clsx from "clsx";
import {
  linkedinLogo,
  facebookLogo,
  whatsappLogo,
} from "@/assets/images";
import styles from "./STSharePopover.module.css";

export const STSharePopover = ({
  children,
  title = "Share",
  shareUrl: customShareUrl,
  placement = "bottom-right",
}) => {
  const shareUrl = customShareUrl || (typeof window !== "undefined" ? window.location.href : "");

  const copyToClipboard = () => {
    navigator.clipboard.writeText(shareUrl).then(() => {
      toast.success("Link copied to clipboard!");
    });
  };

  return (
    <STPopover
      contentClassName={styles.sharePopoverContent}
      content={({ close }) => (
        <>
          <div
            className={clsx(
              styles.shareBoxHeader,
              "d-flex align-items-center justify-content-between gap-3 space-xs-pb space-xs-mb",
            )}
          >
            <h5 className="mb-0">{title}</h5>
            <button
              className={clsx(
                styles.closeBtn,
                "bg-transparent border-0 d-flex align-items-center justify-content-center p-1 text-clr-gray transition-smooth",
              )}
              onClick={close}
            >
              {Icons.closeIcon}
            </button>
          </div>

          <p className="mb-2 fw-medium sm">Copy link</p>
          <div
            className={clsx(
              styles.copyLinkBox,
              "d-flex align-items-start justify-content-between gap-3 bg-off-white text-clr-gray radius-xs space-xs-mb",
            )}
          >
            <p className="mb-0 sm text-ellipsis line-clamp-2 word-break-all">
              {shareUrl}
            </p>
            <button
              className={clsx(
                styles.copyIconBtn,
                "bg-transparent border-0 d-flex align-items-center justify-content-center p-1 text-clr-black transition-smooth",
              )}
              onClick={copyToClipboard}
            >
              {Icons.copyIcon}
            </button>
          </div>

          <p className="mb-2 fw-medium sm">Share via</p>
          <div className="d-flex gap-3">
            <a
              href={`https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(shareUrl)}`}
              target="_blank"
              rel="noopener noreferrer"
              className={clsx(
                styles.socialIcon,
                "d-flex align-items-center justify-content-center cursor-pointer transition-smooth",
              )}
            >
              <Image
                src={linkedinLogo}
                alt="linkedin"
                className="w-100 h-100"
              />
            </a>
            <a
              href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`}
              target="_blank"
              rel="noopener noreferrer"
              className={clsx(
                styles.socialIcon,
                "d-flex align-items-center justify-content-center cursor-pointer transition-smooth",
              )}
            >
              <Image
                src={facebookLogo}
                alt="facebook"
                className="w-100 h-100"
              />
            </a>
            <a
              href={`https://api.whatsapp.com/send?text=${encodeURIComponent(shareUrl)}`}
              target="_blank"
              rel="noopener noreferrer"
              className={clsx(
                styles.socialIcon,
                "d-flex align-items-center justify-content-center cursor-pointer transition-smooth",
              )}
            >
              <Image
                src={whatsappLogo}
                alt="whatsapp"
                className="w-100 h-100"
              />
            </a>
          </div>
        </>
      )}
      placement={placement}
    >
      {children}
    </STPopover>
  );
};
